<template>
  <v-card>
    <v-card-title class="text-h6 mb-3">
      {{ $t("Ghi chú") }}
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click="close">
        {{ $t("Đóng") }}
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-simple-table class="table-padding-2 table-h-36 mt-3 table-no-hover">
        <template v-slot:default>
          <thead class="v-data-table-header">
            <tr>
              <th role="columnheader" class="text-center">Thời gian</th>
              <th role="columnheader" class="text-center">Nhân viên</th>
              <th role="columnheader" class="text-center">Nội dung</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="text-center"
              v-for="(item, index) in items"
              :key="`r_${index}_${item.id}`"
            >
              <td>{{ formatDateTime(item.created_at) }}</td>
              <td>{{ item.account_name }}</td>
              <td>
                <span
                  @click="showImages(item.image)"
                  :class="{
                    'primary--text text-decoration-underline': !!item.image,
                  }"
                >
                  {{ item.note }}
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { httpClient } from "@/libs/http";

export default {
  name: "NoteDialog",
  components: {},
  props: {
    selected: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    items: [],
    isLoading: false,
  }),
  mounted() {
    this.getList();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async getList() {
      const { data } = await httpClient.post("/order/v1/get-note", {
        id_order: this.selected.id,
      });
      this.items = [...data];
    },

  },
};
</script>
